module.exports = __webpack_public_path__ + "static/01-f3280e4027b43abdf714169772475fae.jpg";